<template>
    <v-container class="fill-height" fluid>
          Necesar
    </v-container>
</template>
<script>
export default {
    name: 'Necesar'
}
</script>